import React, {useState, useEffect} from 'react';
import Chart from 'react-apexcharts';
import Title from '../../../../components/Title';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import {
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import DrawTable from '../../../../components/DrawTable';
import DataCard from '../DataCard';
import {
  AnnotationsMonth,
  AnnotationsPremiums,
  getMonthName,
  getPlanName,
  months,
  premiuns,
  responsive,
  responsiveCards,
  responsiveMedium,
  returnTotalValues,
  returnTotalValuesPremium,
  returnValuesPremium,
  returnValuesTotalPremium,
} from '../../service/utils';
import dashboardService from '../../service';
import {KeyboardDatePicker} from '@material-ui/pickers';
import DrawTableDash from '../../../../components/DrawTableDash';
import {GetAppOutlined} from '@material-ui/icons';
import {styles} from './styles';
import {CustomSelect} from './components/CustomSelect';

const formatScreenName = name => {
  const map = {
    home: 'Home',
    bemestar: 'Bem-Estar',
    biblioteca: 'Biblioteca',
    mais: 'Mais',
    buscar: 'Buscar',
    salvos: 'Salvos',
    parceiros: 'Parceiros',
    meumedita: 'Meu Medita',
    valepresente: 'Vale Presente',
    assinaturas: 'Assinaturas',
    centraldeajuda: 'Central de Ajuda',
    playlist: 'Playlist',
    'outras funcionalidades': 'Outras Funcionalidades',
    contato: 'Contato',
    'termos de uso e privacidade': 'Termos de uso e privacidade',
  };

  return map[name] || name;
};

const ScreensItem = () => {
  const screenOrder = [
    'Home',
    'Bem-Estar',
    'Meditações',
    'MiniMedita',
    'Yoga',
    'Mantras',
    'Músicas',
    'Exercícios',
    'Biblioteca',
    'Mais',
    'Buscar',
    'Salvos',
    'Parceiros',
    'Meu Medita',
    'Vale Presente',
    'Assinaturas',
    'Central de Ajuda',
    'Playlist',
    'Outras funcionalidades',
    'Contato',
    'Termos de uso e privacidade',
  ];

  const colorMap = {
    Home: '#1E90FF',
    'Bem-Estar': '#22C55E',
    Meditações: '#316570',
    Conexão: '#ff8795',
    Yoga: '#ffac1c',
    Fé: '#ffdc00',
    Músicas: '#38b2f7',
    Exercícios: '#4cc836',
    Biblioteca: '#0EA5E9',
    Mais: '#F59E0B',
    Buscar: '#14B8A6',
    Salvos: '#EF4444',
    Parceiros: '#8B5CF6',
    'Meu Medita': '#06B6D4',
    'Vale Presente': '#84CC16',
    Assinaturas: '#F43F5E',
    'Central de Ajuda': '#64748B',
    Playlist: '#7C3AED',
    'Outras funcionalidades': '#A16207',
    Contato: '#0F766E',
    'Termos de uso e privacidade': '#6B7280',
  };

  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [screenData, setScreenData] = useState([]);
  const [filters, setFilters] = useState({
    platform: null,
    currentAccountType: null,
  });

  const GetData = async () => {
    setLoading(true);

    const response = await dashboardService.getAccessByScreen({
      startDate,
      endDate,
      filters: {
        platform: filters.platform || null,
        currentAccountType: filters.currentAccountType || null,
      },
    });
    setScreenData(response.data || []);

    setLoading(false);
  };

  useEffect(() => {
    GetData();
  }, [startDate, endDate, filters]);

  const getGradientColor = (index, total) => {
    const ratio = total <= 1 ? 0 : index / (total - 1);

    const start = [164, 239, 208];
    const end = [105, 82, 224];

    const r = Math.round(start[0] + ratio * (end[0] - start[0]));
    const g = Math.round(start[1] + ratio * (end[1] - start[1]));
    const b = Math.round(start[2] + ratio * (end[2] - start[2]));

    return `rgb(${r}, ${g}, ${b})`;
  };

  const sortedData = [...screenData].sort((a, b) => {
    const aIndex = screenOrder.indexOf(formatScreenName(a.screen));
    const bIndex = screenOrder.indexOf(formatScreenName(b.screen));

    return aIndex - bIndex;
  });

  const categories = sortedData.map(item => formatScreenName(item.screen));

  const totalGeneral = sortedData.reduce((acc, item) => acc + item.total, 0);

  const colors = sortedData.map((item, index) => {
    const screenName = formatScreenName(item.screen);

    return colorMap[screenName] || getGradientColor(index, sortedData.length);
  });

  const seriesScreens = [
    {
      name: 'Acessos',
      data: sortedData.map(item => item.total),
    },
  ];

  return (
    <div
      style={{
        margin: 15,
        marginTop: 25,
        padding: 20,
        backgroundColor: '#fff',
        borderRadius: 10,
      }}>
      <div>
        <Typography
          component="h1"
          variant="h6"
          color="inherit"
          noWrap
          style={{marginBottom: 20}}>
          Acessos por Tela
        </Typography>

        <div style={styles.flex}>
          <CustomSelect
            title="Plataforma"
            values={[
              {value: null, label: 'Todos'},
              {value: 'android', label: 'Android'},
              {value: 'ios', label: 'IOS'},
            ]}
            value={filters.platform}
            setValue={event =>
              setFilters({
                ...filters,
                platform: event,
              })
            }
          />

          <CustomSelect
            title="Assinantes"
            values={[
              {value: null, label: 'Todos'},
              {value: 'subscriber', label: 'Sim'},
              {value: 'free', label: 'Não'},
            ]}
            value={filters.currentAccountType}
            setValue={event =>
              setFilters({
                ...filters,
                currentAccountType: event,
              })
            }
          />
          <div style={styles.flexEnd}>
            <div style={styles.datePicker}>
              <KeyboardDatePicker
                placeholder="Selecione data inicial"
                value={startDate}
                onChange={dateForm => {
                  const newStartDate = new Date(dateForm);

                  if (newStartDate > endDate) {
                    setEndDate(newStartDate);
                  }

                  setStartDate(newStartDate);
                }}
                maxDate={endDate}
                format="DD/MM/YYYY"
              />
            </div>

            <div style={styles.datePicker}>
              <KeyboardDatePicker
                placeholder="Selecione data final"
                value={endDate}
                onChange={dateForm => {
                  const newEndDate = new Date(dateForm);

                  if (newEndDate < startDate) {
                    setStartDate(newEndDate);
                  }

                  setEndDate(newEndDate);
                }}
                minDate={startDate}
                format="DD/MM/YYYY"
              />
            </div>
          </div>
        </div>
      </div>
      {loading ? (
        <div className="flex-col center-a center-b">
          <CircularProgress size={100} />
        </div>
      ) : (
        <>
          <div
            style={{
              marginTop: 10,
              marginBottom: 20,
              padding: '12px 16px',
              background: '#f8fafc',
              borderRadius: 10,
              display: 'inline-flex',
              alignItems: 'center',
              gap: 10,
            }}>
            <Typography
              style={{
                fontSize: 14,
                color: '#64748b',
              }}>
              Total Geral:
            </Typography>

            <Typography
              style={{
                fontSize: 24,
                fontWeight: 700,
                color: '#111827',
              }}>
              {totalGeneral.toLocaleString('pt-BR')}
            </Typography>
          </div>
          <Chart
            options={{
              chart: {
                type: 'bar',
                height: 350,
                toolbar: {
                  show: false,
                },
              },

              plotOptions: {
                bar: {
                  horizontal: true,
                  borderRadius: 6,
                  distributed: true,
                  barHeight: '70%',
                },
              },

              colors,

              xaxis: {
                categories,
              },

              grid: {
                borderColor: '#f1f5f9',
              },

              dataLabels: {
                enabled: true,

                formatter: (val, opts) => {
                  const index = opts.dataPointIndex;

                  const perc = (sortedData[index].percentage * 100).toFixed(1);

                  return `${val} (${perc}%)`;
                },

                style: {
                  fontSize: '11px',
                  fontWeight: 600,
                },
              },

              tooltip: {
                y: {
                  formatter: (val, opts) => {
                    const index = opts.dataPointIndex;

                    const perc = (sortedData[index].percentage * 100).toFixed(
                      2,
                    );

                    return `${val} acessos (${perc}%)`;
                  },
                },
              },

              legend: {
                show: false,
              },
            }}
            series={seriesScreens}
            type="bar"
            height={650}
          />
        </>
      )}
    </div>
  );
};

export default ScreensItem;
